package presentation.screens.business.employee

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.button.DefaultButton
import component.empty.EmptyData
import component.input.SearchBar
import component.loader.AppLoader
import component.navigation.TopNavBar
import feature.employee.viewModel.EmployeeViewModel
import presentation.screens.business.employee.component.EmployeeCard
import presentation.screens.business.employee.create.CreateEmployeeScreen
import presentation.screens.business.employee.edit.EditEmployeeScreen
import theme.ThemeColor

class EmployeeListScreen : Screen {
    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val viewModel = EmployeeViewModel()
        val allEmployee = viewModel.allEmployee.collectAsState()
        val searchQuery = viewModel.searchQuery.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.fetchAllEmployee()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Employee", onBackPress = {
                navigator?.pop()
            }, onClickAdd = {
                navigator?.push(CreateEmployeeScreen())
            })
            AppLoader(viewModel)
            SearchBar(viewModel, searchQuery.value, "Search Employee")
            LazyColumn(modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)) {
                item {
                    if (allEmployee.value.isEmpty()) {
                        EmptyData(viewModel = viewModel)
                        DefaultButton(
                            "Add New Employee",
                            onClick = { navigator?.push(CreateEmployeeScreen()) })
                    } else {
                        Box(
                            modifier = Modifier
                                .height(50.dp)
                                .padding(start = 8.dp, end = 8.dp)
                                .background(
                                    ThemeColor.shared().cardBackground,
                                    shape = RoundedCornerShape(10.dp)
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = "Total ${allEmployee.value.count()} employee",
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier
                                    .wrapContentHeight().fillMaxWidth(),
                                textAlign = TextAlign.Center,
                                color = ThemeColor.shared().PrimaryColor
                            )
                        }
                    }
                }
                items(count = allEmployee.value.count()) { index ->
                    EmployeeCard(allEmployee.value[index]) {
//                        viewModel.editCustomer(it)
                        navigator?.push(EditEmployeeScreen())
                    }
                }
            }
        }
    }

}